import { Asset } from 'expo-asset';
import * as Font from 'expo-font';
import * as SplashScreen from 'expo-splash-screen';
import { Ionicons } from '@expo/vector-icons';

import * as React from 'react';
import { StyleProvider, Root } from 'native-base';
import { NativeModules, LayoutAnimation, Platform } from 'react-native';

import { Provider } from 'react-redux';

import configureStore from './configureStore';
import Alert from '../components/alert';
import { App } from '../App'; //NavigationStack
import Splash from '../components/splash';

import getTheme from '../theme/components';
//import getTheme from './native-base-theme/components';
import variables from '../theme/variables/platform';
import LocalStorage from '../api/LocalStorage';
import CalCalDataApi from '../api/CalCalDataApi';
import jwt_decode from 'jwt-decode';
import stopLogs from './stopLogs';
import { Portal } from 'react-native-paper';

//import { ReduxNetworkProvider } from 'react-native-offline';

export default class Setup extends React.Component {
	constructor() {
		super();
		this.store = configureStore(() => this.setState({ isLoading: false }));
		this.state = {
			isLoading: false,
			//store: store,
			//persistor: persistor,
			isReady: false,
			checkedSignIn: false,
			signedIn: null,
			showReloadDialog: false
		};
		const { UIManager } = NativeModules;

		UIManager.setLayoutAnimationEnabledExperimental && UIManager.setLayoutAnimationEnabledExperimental(true);
		stopLogs();
	}

	async componentDidMount() {
		// Prevent native splash screen from autohiding
		try {
			await SplashScreen.preventAutoHideAsync();
		} catch (e) {
			//console.warn(e);
		}
		this.loadResourcesAsync();
	}

	async loadResourcesAsync() {
		await Promise.all([
			Asset.loadAsync([
				require('../../assets/cl-1.jpg'),
				require('../../assets/customer.png'),
				require('../../assets/supplier.png'),
				require('../../assets/C-32-wh.png'),
				require('../../assets/drawer-calcal.png'),
				require('../../assets/logo-kitchen-sink.png')
			]),
			Font.loadAsync({
				Roboto: require('../../node_modules/native-base/Fonts/Roboto.ttf'),
				Roboto_medium: require('../../node_modules/native-base/Fonts/Roboto_medium.ttf'),
				//ionicons: require('../../node_modules/@expo/vector-icons/build/vendor/react-native-vector-icons/Fonts/Ionicons.ttf'),
				FontAwesome: require('../../node_modules/@expo/vector-icons/build/vendor/react-native-vector-icons/Fonts/FontAwesome.ttf'),
				transactiontypes: Platform.OS == 'web' && require('../../assets/fonts/transactiontypes.ttf'),
				...Ionicons.font
			}),
			this.checkSignedIn(),
			this.checkWebToken()
		]);
		//console.log('Promises fin');
		this.setState({ isReady: true }, async () => {
			try {
				await SplashScreen.hideAsync();
			} catch (e) {
				//console.warn(e);
			}
		});
	}
	async checkSignedIn() {
		const signedIn = await LocalStorage.getUserAsync(); //this gets from securestore or (web) just gives us {access_token, 999999999}
		//native, will refresh if necessary
		__DEV__ && console.log('back ', signedIn);
		LayoutAnimation.easeInEaseOut();

		signedIn &&
			this.store.dispatch({
				type: 'SET_USER',
				user: signedIn
			});
		this.setState({ checkedSignIn: true });
		//console.log('checkedSignIn');
	}

	async checkWebToken() {
		//duplicated this from pin screen to prevent the back and forth. Checks if there's a JWT already
		if (Platform.OS != 'web') return;
		const jwt = await LocalStorage.getJWT();
		__DEV__ && console.log('SETUP jwt', jwt);
		if (!jwt) return LocalStorage.removeUserAsync();
		let userinfo;
		try {
			userinfo = jwt_decode(jwt.token.token);
		} catch (e) {
			LocalStorage.removeUserAsync();
			return;
		}

		this.store.dispatch({
			type: 'SET_JWT',
			token: jwt.token,
			info: userinfo
		});

		const initLoad = await LocalStorage.getInitLoad(userinfo.sub);
		__DEV__ && console.log('Got local initLoad', initLoad);

		if (!!initLoad) {
			console.log('loading Prev saved stuff');
			this.store.dispatch({
				type: 'Init/InitLoad',
				data: initLoad
			});
		}

		//won't wait for this since it's callback
		CalCalDataApi.dataLoad('initLoad', jwt.token.token, res => {
			if (!res.error && !res.exception) {
				console.log('GOT and saving initLoad');
				LocalStorage.saveInitLoad(userinfo.sub, res);
				this.store.dispatch({
					type: 'Init/InitLoad',
					data: res
				});
			}
			/*if (userinfo.user.needspin) {
				navigate doesnt work here
				this.store.navigation.navigate({ name: 'Pin', params: { change: 'temp' } });
			}*/

			//console.log('initLoad ', res);
		});
	}

	render() {
		if (!this.state.isReady) {
			//images and fonts loading
			return null;
		}
		if (!this.state.checkedSignIn) {
			return <Splash signedIn={this.state.checkedSignIn} />;
		}

		return (
			<StyleProvider style={getTheme(variables)}>
				<Root>
					<Provider store={this.store}>
						<App />
					</Provider>
					{Platform.OS == 'web' && <Alert />}
				</Root>
			</StyleProvider>
		);
	}
}
